import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Landing from './Landing/Landing';
import BookAppointment from './Booking/BookAppointment';
import CollectionDetail from './Collections/CollectionDetail';
import About from './About/About';
import CategoriesIndex from './Categories/CategoriesIndex';
import CategoryListing from './Categories/CategoryListing';
import DressDetail from './Categories/DressDetail';
import ScrollToTop from './components/ScrollToTop';
import WhatsNewModal from './components/WhatsNewModal';
import WhatsAppFloat from './components/WhatsAppFloat';
import './components/WhatsAppFloat.css';
import useRealViewportHeight from './components/useRealViewportHeight';
import { IdentityProvider } from './Admin/IdentityContext';
import RequireIdentity from './Admin/RequireIdentity';
import AdminLogin from './Admin/AdminLogin';
import AdminLayout from './Admin/AdminLayout';
import CollectionsListView from './Admin/CollectionsListView';
import CollectionForm from './Admin/CollectionForm';
import CategoriesListView from './Admin/CategoriesListView';
import CategoryForm from './Admin/CategoryForm';
import DressForm from './Admin/DressForm';

// The floating contact belongs to the storefront, not the admin console —
// and useLocation only works inside the router, hence the small wrapper.
function PublicChrome() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin')) return null;
  return <WhatsAppFloat />;
}

export default function App() {
  useRealViewportHeight();
  return (
    // Identity is initialized once here, globally — not scoped to /admin —
    // because Netlify's invite/recovery emails link to the site root with a
    // #token in the URL, and the widget only picks that token up if init()
    // has run on whatever page the link happens to land on.
    <IdentityProvider>
      <BrowserRouter>
        <ScrollToTop />
        <WhatsNewModal />
        <PublicChrome />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/book-appointment" element={<BookAppointment />} />
          <Route path="/collections/:slug" element={<CollectionDetail />} />
          <Route path="/categories" element={<CategoriesIndex />} />
          <Route path="/categories/:categorySlug" element={<CategoryListing />} />
          <Route path="/categories/:categorySlug/:dressSlug" element={<DressDetail />} />
          <Route path="/about" element={<About />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireIdentity />}>
            <Route element={<AdminLayout />}>
              <Route index element={<CollectionsListView />} />
              <Route path="collections/new" element={<CollectionForm mode="new" />} />
              <Route path="collections/:slug" element={<CollectionForm mode="edit" />} />

              <Route path="categories" element={<CategoriesListView />} />
              <Route path="categories/new" element={<CategoryForm mode="new" />} />
              <Route path="categories/:categorySlug" element={<CategoryForm mode="edit" />} />
              <Route path="categories/:categorySlug/dresses/new" element={<DressForm mode="new" />} />
              <Route path="categories/:categorySlug/dresses/:dressSlug" element={<DressForm mode="edit" />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </IdentityProvider>
  );
}
